export default "__VITE_ASSET__2db483e8__"